import { CurveLineIcon } from '@/assets/icons';
import { TREND_CHART_SIPLE_CARD_TEST_IDS } from '@/constants/data-testids';
import { cn } from '@/utils/tailwind';

import { Card, CardContent } from '../../atoms/Card/Card';
import { Skeleton } from '../../atoms/Skeleton/Skeleton';

export const TrendChartSkeleton = () => {
  return (
    <Card
      data-testid={TREND_CHART_SIPLE_CARD_TEST_IDS.SKELETON}
      className="p-4 border-custom-warm-grey-150"
    >
      <CardContent>
        <div className="flex gap-[10px] flex-col sm:flex-row justify-between min-h-[18px] mb-6">
          <div>
            <Skeleton className="w-[140px] h-[14px]" />
          </div>
          <div className="flex justify-start sm:justify-end flex-wrap gap-3">
            {Array.from({ length: 5 }, (_, i) => (
              <div className="flex items-center gap-2" key={i}>
                <Skeleton className="w-3 h-3 rounded-full" />
                <Skeleton className="w-[107px] h-[14px] rounded-sm" />
              </div>
            ))}
          </div>
        </div>
        <div className="flex gap-3 mb-[18px] pr-[39px]">
          <div className="flex flex-col gap-[47.5px]">
            {Array.from({ length: 5 }, (_, i) => (
              <Skeleton key={i} className="w-[30px] h-[14px] rounded-[4px]" />
            ))}
          </div>
          <div className="relative w-full overflow-hidden flex flex-col">
            <CurveLineIcon className="relative h-full z-10 animate-pulse" />
            <CurveLineIcon className="relative h-full z-10 animate-pulse rotate-180" />
            <CurveLineIcon className="relative h-full z-10 animate-pulse" />
            <CurveLineIcon className="relative h-full z-10 animate-pulse rotate-180" />

            <span
              className="absolute top-[5px] w-full h-[1px] animate-pulse"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, #F0EEED 33.33%, transparent 33.33%, transparent 66.66%, #F0EEED 66.66%)',
                backgroundSize: '24px 100%',
              }}
            />

            <span
              className="absolute top-[68px] w-full h-[1px] animate-pulse"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, #F0EEED 33.33%, transparent 33.33%, transparent 66.66%, #F0EEED 66.66%)',
                backgroundSize: '24px 100%',
              }}
            />

            <span
              className="absolute top-[129px] w-full h-[1px] animate-pulse"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, #F0EEED 33.33%, transparent 33.33%, transparent 66.66%, #F0EEED 66.66%)',
                backgroundSize: '24px 100%',
              }}
            />

            <span
              className="absolute top-[192px] w-full h-[1px] animate-pulse"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, #F0EEED 33.33%, transparent 33.33%, transparent 66.66%, #F0EEED 66.66%)',
                backgroundSize: '24px 100%',
              }}
            />

            <span
              className="absolute top-[252px] w-full h-[1px] animate-pulse"
              style={{
                backgroundImage:
                  'linear-gradient(90deg, #F0EEED 33.33%, transparent 33.33%, transparent 66.66%, #F0EEED 66.66%)',
                backgroundSize: '24px 100%',
              }}
            />
          </div>
        </div>
        <div className="flex items-center justify-between mr-[39px] ml-[42px]">
          {Array.from({ length: 12 }, (_, i) => (
            <Skeleton
              key={i}
              className={cn('w-[40px] h-[14px] rounded-[4px]', {
                'hidden sm:block': i <= 2,
                'hidden lg:block': i >= 6,
              })}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
